// Форматирование дат/чисел/статусов - все локали ru-RU.

export function fmtDate(iso: string): string {
  const clean = iso.length === 10 ? iso + 'T00:00:00Z' : iso;
  return new Date(clean).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  });
}

export function fmtMoney(rub: number): string {
  return new Intl.NumberFormat('ru-RU').format(rub) + ' ₽';
}

/** Русское склонение по числу: 1 день, 2 дня, 5 дней. */
export function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) return few;
  return many;
}

export function fmtRelativeTime(iso: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso).getTime();
  // Битая строка даёт Invalid Date, и арифметика по ней печатала «NaN дней назад».
  // Прочерк честнее: он говорит «времени нет», а не выдумывает его.
  if (Number.isNaN(d)) return '-';
  const now = Date.now();
  const diffMin = Math.round((now - d) / 60_000);
  if (diffMin < 1) return 'только что';
  if (diffMin < 60) return `${diffMin} мин назад`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `${diffH} ч назад`;
  const diffD = Math.round(diffH / 24);
  // «2 дн назад» читалось как обрубок. Числа в интерфейсе склоняются.
  return `${diffD} ${plural(diffD, 'день', 'дня', 'дней')} назад`;
}

/**
 * Когда это было, коротко: сегодня - часы, раньше - дата. Для строк вроде
 * «гость писал 12:40» и «гость писал 31 авг».
 */
export function fmtWhen(iso: string | null): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  const today = new Date();
  if (d.toDateString() === today.toDateString()) {
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  }
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' }).replace('.', '');
}
